export const DATE_FORMAT_USER = "mm/dd/yyyy";

export const COMPANY_NAME = "SUPERVALU";

export const enum SV_SIMPLE_PAGE {
  ORDER_NOT_FOUND = "ORDER_NOT_FOUND",
  TECHNICAL_DIFFICULTIES = "TECHNICAL_DIFFICULTIES"
}